"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendingDomainCommonStatus = exports.ComplianceStatus = void 0;
var ComplianceStatus;
(function (ComplianceStatus) {
    ComplianceStatus["Pending"] = "pending";
    ComplianceStatus["Valid"] = "valid";
    ComplianceStatus["Blocked"] = "blocked";
})(ComplianceStatus = exports.ComplianceStatus || (exports.ComplianceStatus = {}));
var SendingDomainCommonStatus;
(function (SendingDomainCommonStatus) {
    SendingDomainCommonStatus["Unverified"] = "unverified";
    SendingDomainCommonStatus["Pending"] = "pending";
    SendingDomainCommonStatus["Invalid"] = "invalid";
    SendingDomainCommonStatus["Valid"] = "valid";
})(SendingDomainCommonStatus = exports.SendingDomainCommonStatus || (exports.SendingDomainCommonStatus = {}));
//# sourceMappingURL=sending-domain-status.js.map